import { render, staticRenderFns } from "./component-objective-header-actions.vue?vue&type=template&id=d0b81f5a&scoped=true"
import script from "./component-objective-header-actions.ts?vue&type=script&lang=ts&external"
export * from "./component-objective-header-actions.ts?vue&type=script&lang=ts&external"
import style0 from "./component-objective-header-actions.less?vue&type=style&index=0&id=d0b81f5a&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b81f5a",
  null
  
)

export default component.exports